import React, { useState } from 'react';
import './ProductImageGallery.css';
import ImageZoomModal from './ImageZoomModal';

const ProductImageGallery = ({ images, productTitle }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isZoomOpen, setIsZoomOpen] = useState(false);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToImage = (index) => {
    setCurrentImageIndex(index);
  };

  if (!images || images.length === 0) {
    return (
      <div className="image-gallery">
        <div className="main-image-container">
          <div className="no-image">No Image Available</div>
        </div>
      </div>
    );
  }

  return (
    <div className="image-gallery">
      {/* Main Image Display */}
      <div className="main-image-container">
        <img 
          src={images[currentImageIndex]} 
          alt={`${productTitle} - Image ${currentImageIndex + 1}`}
          className="main-image"
          onClick={() => setIsZoomOpen(true)}
        />
        
        {/* Navigation Arrows */}
        {images.length > 1 && (
          <>
            <button 
              className="nav-arrow prev-arrow"
              onClick={prevImage}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <button 
              className="nav-arrow next-arrow"
              onClick={nextImage}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </>
        )}

        {/* Image Counter */}
        {images.length > 1 && (
          <div className="image-counter">
            {currentImageIndex + 1} / {images.length}
          </div>
        )}
      </div>

      {/* Thumbnail Indicators */}
      {images.length > 1 && (
        <div className="thumbnail-indicators">
          {images.map((image, index) => (
            <button
              key={index}
              className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
              onClick={() => goToImage(index)}
            >
              <img 
                src={image} 
                alt={`Thumbnail ${index + 1}`}
              />
            </button>
          ))}
        </div>
      )}

      {/* Dot Indicators (Alternative to thumbnails for mobile) */}
      {images.length > 1 && (
        <div className="dot-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentImageIndex ? 'active' : ''}`}
              onClick={() => goToImage(index)}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      )}
      <ImageZoomModal
        isOpen={isZoomOpen}
        images={images}
        initialIndex={currentImageIndex}
        productTitle={productTitle}
        onClose={() => setIsZoomOpen(false)}
        onIndexChange={(nextIndex) => setCurrentImageIndex(nextIndex)}
      />
    </div>
  );
};

export default ProductImageGallery;
